import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { TestEventFilters } from "@/api/williams/testEvents";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useTestEventList(filters: Partial<TestEventFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.testEvent.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getTestEvents({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
